<template>
  <div>
    <header class="sw-header sw-header-fixed">
      <b-navbar style="padding-left: 0;"  toggleable="lg">
        <div class="logo">
          <img src="images/logo-white.svg">
        </div>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-navbar-nav class="sw-header-nav">
          <b-nav-form style="margin-right:40px">
            <b-input-group size="sm"  prepend="Buscar paciente:">
                <b-form-input></b-form-input>
            </b-input-group>
          </b-nav-form>
          <!-- Navbar dropdowns -->
        </b-navbar-nav> 
        <div style="position: absolute;right: 67px;">
          <b-dropdown id="dropdown-right" right text="Menú usuario" variant="primary">
            <b-dropdown-item @click="logout">Cerrar Sesión</b-dropdown-item>
          </b-dropdown>
        </div>
      </b-navbar>
    </header>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: "center-layout",
  methods: 
  {  
    ...mapActions({
        logout:     'authStore/logout',
    })
  }
  
};
</script>

<style lang="scss">
.sw-header-fixed{
  position: fixed;
  width: 100%;
  z-index:3;
}
.dropdown-item.active, .dropdown-item:active {
    background-color: #fff !important;
    border-color: #fff !important;
    color: #343434 !important;
}
.sw-header {
  padding-top: 5px;
  background: #006FE6;
  height: 65px;
  flex-shrink: 0;
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,.05), inset 0 -1px 0 rgba(0,0,0,.1);
}
.sw-header .logo {
  text-align:center;
  width: 200px;
}
.sw-header .logo img{
  width: 85px;
  height: 100%;
}
.sw-header-nav .nav-item a{
  color: #f8f9fa !important;
}
.sw-header-nav .nav-item a.dropdown-item{
  color: #212529 !important;
}
.sw-header-nav .nav-item a.dropdown-item:active{
  color: white !important;
}
.bg-sw{
  background: #563d7c
}
.sw-header-nav .nav-item .sw-path-active a.dropdown-item:active
{
  color: #f8f9fa !important;
  background-color: #563d7c;
}
</style>

